export function textFilterMatch(text: string, filter: string) {
    const textString = text ? text : '';
    const filterString = filter ? filter : '';

    return normalizeString(textString)
        .toLowerCase()
        .includes(
            normalizeString(filterString)
                .toLowerCase()
        );
}

export function normalizeString(value: string) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}